// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2MQYH","center":"Title_center__N9qVn","medium":"Title_medium__2i-5x"};